import { render, staticRenderFns } from "./ProjectsTable.vue?vue&type=template&id=0c6f09a5&scoped=true&"
import script from "./ProjectsTable.vue?vue&type=script&lang=js&"
export * from "./ProjectsTable.vue?vue&type=script&lang=js&"
import style0 from "../assets/scss/projectsTable.scss?vue&type=style&index=0&id=0c6f09a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6f09a5",
  null
  
)

export default component.exports